// eslint-disable-next-line import/no-cycle
import AuthService from "../../AuthService";

const about = {
  getAbout(page) {
    return AuthService.get(`/about/about?page=${page}`);
  },
  showAbout(id) {
    return AuthService.get(`/about/about/${id}`);
  },
  createAbout(data) {
    return AuthService.post("/about/about", data);
  },
  updateAbout(id, data) {
    return AuthService.put(`/about/about/${id}`, data);
  },
  deleteAbout(id) {
    return AuthService.delete(`/about/about/${id}`);
  }
};
export default about;
